import { getPosts } from "@r8er/lib/cms";
import { classes, Unpromisify } from "@r8er/lib/utils";
import { PropsWithChildren } from "react";
import Carousel, { ResponsiveType } from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Content } from "../content";
import ourTeamStyles from "./our-team.module.css";

const CustomRightArrow = ({ onClick, ...rest }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <button
      className={classes(
        "react-multiple-carousel__arrow react-multiple-carousel__arrow--right",
        ourTeamStyles.arrows,
        ourTeamStyles.arrowRight
      )}
      onClick={() => onClick()}
    />
  );
};

const CustomLeftArrow = ({ onClick, ...rest }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <button
      className={classes(
        "react-multiple-carousel__arrow react-multiple-carousel__arrow--left",
        ourTeamStyles.arrows,
        ourTeamStyles.arrowLeft
      )}
      onClick={() => onClick()}
    />
  );
};

const ButtonGroup = ({ next, previous }) => {
  return (
    <div
      className={classes(ourTeamStyles.arrowsGroup, "carousel-button-group")}
    >
      <CustomLeftArrow onClick={() => previous()} />
      <CustomRightArrow onClick={() => next()} />
    </div>
  );
};
const responsiveBreaks: ResponsiveType = {
  max: {
    items: 4,
    breakpoint: {
      min: 1340,
      max: 10000,
    },
  },
  mid: {
    items: 3,
    breakpoint: {
      min: 1000,
      max: 1340,
    },
  },
  low: {
    items: 2,
    breakpoint: {
      min: 800,
      max: 1000,
    },
  },
  single: {
    items: 1,
    breakpoint: {
      min: 0,
      max: 800,
    },
  },
};

export const OurPartners = ({
  items,
  children,
}: PropsWithChildren<{ items: Unpromisify<ReturnType<typeof getPosts>> }>) => {
  return (
    <Content
      backgroundImage="/about-seats.png"
      isFullWidth
      isRightAligned
      isLightGrey
    >
      {children}
      <div style={{ padding: "0 50px" }}>
        <Carousel
          infinite
          arrows={false}
          renderButtonGroupOutside
          // @ts-ignore
          customButtonGroup={<ButtonGroup />}
          renderArrowsWhenDisabled
          className={ourTeamStyles.ourTeamSection}
          responsive={responsiveBreaks}
          containerClass={ourTeamStyles.ourTeamSectionContainer}
        >
          {items.map((item) => (
            <div
              className={ourTeamStyles.ourTeamSectionItem}
              key={`ourR8ER_${item.slug}`}
            >
              <img className={ourTeamStyles.image} src={item.feature_image} />
              <div className={ourTeamStyles.title}>{item.title}</div>
              <div
                className={ourTeamStyles.bio}
                dangerouslySetInnerHTML={{ __html: item.html }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </Content>
  );
};
